import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/auto_ventas/ingresos/ingresosEditar';
import IngresosFormEditar from './IngresosFormEditar';


const ms2p = (state) => {
  return {
    ...state.auto_ventas_ingresos_editar,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p,)(IngresosFormEditar);
